import { render, staticRenderFns } from "./BedSetting.vue?vue&type=template&id=75da1f15&scoped=true"
import script from "./BedSetting.vue?vue&type=script&lang=js"
export * from "./BedSetting.vue?vue&type=script&lang=js"
import style0 from "./BedSetting.vue?vue&type=style&index=0&id=75da1f15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75da1f15",
  null
  
)

export default component.exports